import axios from 'axios';

export const state = () => ({
    filters: {}
});

export const getters = {
    filters: state => state.filters
};

export const mutations = {
    SET_FILTERS(state, filters) {
        state.filters = filters;
    }
};

export const actions = {
    index(vuexContext, { order, sortBy, page, filters }) {
        const params = {
            page,
            order: [`${sortBy} ${order === 'ascend' ? 'asc' : 'desc'}`],
            ...filters
        };

        return axios.$get('v1/moderation/events/', {
            params
        });
    },

    async getFilters({ commit }, { order, sortBy, page, filters }) {
        const params = {
            page,
            order: [`${sortBy} ${order === 'ascend' ? 'asc' : 'desc'}`],
            ...filters
        };

        const { results } = await axios.$get('v1/moderation/filters', {
            params
        });

        commit('SET_FILTERS', results);

        return results;
    },

    exportToCsv(vuexContext, { order, sortBy, page, filters }) {
        const params = {
            page,
            order: [`${sortBy} ${order === 'ascend' ? 'asc' : 'desc'}`],
            ...filters
        };

        //@TMP - waiting for backend fix
        return axios.$get('v1/moderation/events/export-to-csv', {
            params
        });
    }
};
